type MediaType = "sm" | "md" | "lg" | "xl";

const medias = { sm: 576, md: 768, lg: 992, xl: 1200 };

export const mqMinScreen = (type: MediaType) => {
  return `@media (min-width: ${medias[type]}px)`;
};
